import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment/orders'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });


export default class OrdersApi {

    static async createOrder({ data = { timeScheduled: undefined, skladName: undefined, shopsDate: undefined }, ...params }) {
        return await fetchService({ url: '/create', method: 'POST', data, ...params })
    }

    static async getOrders({ data = { orderDate: undefined, status: undefined, limit: undefined, page: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getorders', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async deleteOrder({ data = { orderId: undefined }, ...params }) {
        return await fetchService({ url: '/deleteOrder', method: 'DELTETE', data, notify: { msg: 'Заказ удалён' }, ...params })
    }



    static async getOrderProductsItems({ data = { orderIds: undefined, markets: undefined, shop: undefined, tab: undefined, status: undefined, sortType: undefined, search: undefined, providerId: undefined, limit: undefined, page: undefined, filters: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getorderitems', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getLists({ data = { orderIds: undefined, market: undefined, listMarkets: undefined, tab: undefined, sortType: undefined, providerId: undefined, limit: undefined, page: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getlists', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeOrderData({ data = { orderId: undefined, providerSku: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeorderdata', method: 'PATCH', data, ...params })
    }

    static async changeOrdersData({ data = { orderId: undefined, ids: undefined, providerSkus: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeordersdata', method: 'PATCH', data, ...params })
    }




    static async excelTemplateUpload({ data = undefined, ...params }) {
        return await fetchService({ url: '/exceltemplateupload', method: 'GET', data, options: { download: true }, ...params })
    }

    static async formOrder({ data = { orderId: undefined, providerId: undefined, config: undefined, markets: undefined }, ...params }) {
        return await fetchService({ url: '/formorder', method: 'POST', data, ...params })
    }

    static async loadOrderData({ data = { fileName: undefined, autoBill: undefined, orderId: undefined, billNumber: undefined, providerId: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/loadorderdata', method: 'POST', data, ...params })
    }


    static async changeBill({ data = { billId: undefined, newBill: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changebill', method: 'PATCH', data, ...params })
    }

    static async changeBillItem({ data = { billItemId: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changebillitem', method: 'PATCH', data, ...params })
    }

    static async deleteBill({ data = { billId: undefined }, ...params }) {
        return await fetchService({ url: '/deletebill', method: 'DELETE', data, ...params })
    }

    static async downloadBill({ data = { billId: undefined }, ...params }) {
        return await fetchService({ url: '/downloadbill', method: 'POST', data, options: { download: true }, ...params })
    }

}